import { createContext } from "react";

const StyleContext = createContext({});

export default StyleContext;
